import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../hooks/useAuth";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import NavigationHeader from "@/components/ui/navigation-header";
import {
  Home,
  QrCode,
  User,

  Settings,

  Package,
} from "lucide-react";
import { cn } from "../lib/utils";

const CajeroLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // const { logout } = useAuth();

  // const handleLogout = async () => {
  //   try {
  //     await logout();
  //     navigate("/login");
  //   } catch (error) {
  //     console.error("Error during logout:", error);
  //   }
  // };

  const navigationItems = [
    {
      name: "Dashboard",
      href: "/dashboard",
      icon: Home,
      description: "Panel principal",
    },
    {
      name: "Modo Cajero",
      href: "/cajero",
      icon: QrCode,
      description: "Sistema de entrega QR",
      highlight: true,
    },
    {
      name: "Perfil",
      href: "/profile",
      icon: User,
      description: "Configuración personal",
    },
    {
      name: "KDS",
      href: "/KDS",
      icon: Package,
      description: "Pedidos en cola",
    },
  ];

  // Logo personalizado para el cajero
  const cajeroLogo = (
    <div className="flex items-center space-x-2">
      <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center shadow-sm">
        <Package className="h-6 w-6 text-primary-foreground" />
      </div>
      <div>
        <h1 className="text-lg md:text-xl font-bold text-card-foreground">
          Rincón Chilenito
        </h1>
        <p className="text-xs text-muted-foreground hidden sm:block text-left">
          Modo Cajero
        </p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-background">
      {/* Header Unificado */}
      <NavigationHeader
        variant="cajero"
        title="Rincón Chilenito"
        subtitle="Modo Cajero"
        logo={cajeroLogo}
        showCart={false}
        showThemeToggle={false}
        showUserMenu={true}
        userMenuVariant="compact"
      />

      {/* Navegación simplificada */}
      <nav className="border-b bg-muted/30">
        <div className="container mx-auto px-4">
          <div className="flex items-center gap-1 py-2">
            {navigationItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.href;

              return (
                <Button
                  key={item.name}
                  variant={isActive ? "default" : "ghost"}
                  size="sm"
                  onClick={() => navigate(item.href)}
                  className={cn(
                    "flex items-center gap-2 transition-colors",
                    isActive &&
                      item.highlight &&
                      "bg-primary text-primary-foreground shadow-sm"
                  )}
                >
                  <Icon className="h-4 w-4" />
                  <span className="hidden sm:inline">{item.name}</span>
                  {item.highlight && (
                    <Badge variant="secondary" className="ml-1 text-xs">
                      QR
                    </Badge>
                  )}
                </Button>
              );
            })}
          </div>
        </div>
      </nav>

      {/* Contenido principal */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer minimalista */}
      <footer className="border-t bg-gradient-to-r from-muted/30 to-muted/20 backdrop-blur-sm py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            {/* Información del sistema */}
            <div className="flex flex-col sm:flex-row items-center gap-4 text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Package className="h-3 w-3 text-primary" />
                </div>
                <span className="font-medium">Sistema de Entrega QR</span>
              </div>
              <div className="hidden sm:block w-px h-4 bg-border"></div>
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 bg-gradient-to-br from-primary to-primary/80 rounded-lg flex items-center justify-center">
                  <span className="text-primary-foreground font-bold text-xs">
                    C
                  </span>
                </div>
                <span className="font-medium">Chilenito SPA</span>
              </div>
            </div>

            {/* Versión y estado */}
            <div className="flex items-center gap-3 text-sm text-muted-foreground">
              <div className="flex items-center gap-2 px-3 py-1 bg-primary/10 rounded-full">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span className="text-xs font-medium">Online</span>
              </div>
              <div className="flex items-center gap-2">
                <Settings className="h-4 w-4" />
                <span className="font-mono text-xs">v1.0.0</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CajeroLayout;
